var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dropdown, MenuItem, FormController, FormLabel, } from '@one-thd/sui-atomic-components';
export var formatCityState = function (city, state) {
    return "".concat(city, ", ").concat(state);
};
export var CityStateSelect = function (props) {
    var cities = props.cities, value = props.value;
    return (React.createElement("div", { className: "sui-relative sui-z-10" },
        React.createElement(FormController, { fullWidth: true },
            React.createElement(FormLabel, null, "City, State"),
            React.createElement(Dropdown, __assign({ key: value, placeholder: "" }, props), cities === null || cities === void 0 ? void 0 : cities.map(function (_a) {
                var city = _a.city, state = _a.state;
                return (React.createElement(MenuItem, { key: city, value: formatCityState(city, state) }, formatCityState(city, state)));
            })))));
};
